import { Link as MUILink } from '@mui/material'
import type { SxProps } from '@mui/material'

interface ILinkProps {
  sx?: SxProps
  href: string
  children: React.ReactNode
  external?: boolean
  download?: boolean
  underline?: 'none' | 'hover' | 'always'
  onClick?: () => void
  color?: string
  bold?: boolean
}
export default function Link({ color, sx, href, children, external, download, onClick, underline, bold }: ILinkProps) {
  if (!href) return <span>{children}</span>
  const hasHTTP = href.startsWith('http://') || href.startsWith('https://')
  if (!hasHTTP && external) href = `https://${href}`
  return (
    <MUILink
      sx={{
        ...(bold ? { fontWeight: 'bold' } : {}),
        ...sx,
      }}
      href={href}
      target={external ? '_blank' : undefined}
      download={download}
      underline={underline}
      onClick={onClick}
      color={color}
    >
      {children}
    </MUILink>
  )
}
